import { ActionIcon, Badge, Group, Menu, Paper, Stack, Text } from "@mantine/core";
import { IconDotsVertical, IconEdit, IconTrash } from "@tabler/icons-react";
import { useCallback } from "react";

type CriterioListItemProperties = {
  criterio: TCriterioRubrica;
  index: number;
  onEdit: (criterio: TCriterioRubrica, index: number) => void;
  onRemove: (index: number) => void;
};

/**
 * Renderiza um item de critério na lista
 * @param props - Propriedades do componente
 * @param props.criterio
 * @param props.index
 * @param props.onEdit
 * @param props.onRemove
 */
function CriterioListItem({ criterio, index, onEdit, onRemove }: CriterioListItemProperties): JSX.Element {
  const handleEdit = useCallback(() => {
    onEdit(criterio, index);
  }, [criterio, index, onEdit]);

  const handleRemove = useCallback(() => {
    onRemove(index);
  }, [index, onRemove]);

  return (
    <Paper withBorder p="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>
          <Group gap="xs">
            <Text fw={600}>{criterio.nome || "Criterio sem nome"}</Text>
            <Badge variant="light">Peso {criterio.peso}</Badge>
            {criterio.obrigatorio && <Badge color="green">Obrigatorio</Badge>}
          </Group>
          <Text size="sm" c="dimmed">
            {criterio.descricao || "Sem descricao"}
          </Text>
          <Text size="xs" c="dimmed">
            Escala: {criterio.escalaMin} a {criterio.escalaMax} | Guia: {Object.keys(criterio.guiaNotas || {}).length}{" "}
            notas
          </Text>
        </Stack>
        <Menu shadow="md" width={160} position="left" withArrow arrowPosition="center">
          <Menu.Target>
            <ActionIcon variant="subtle" aria-label="Acoes do criterio" color="gray">
              <IconDotsVertical size={16} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item leftSection={<IconEdit size={14} />} onClick={handleEdit}>
              Editar
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item color="red" leftSection={<IconTrash size={14} />} onClick={handleRemove}>
              Remover
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </Paper>
  );
}

export default CriterioListItem;
